import { render, staticRenderFns } from "./ToolkitsForm.vue?vue&type=template&id=71a1d249&"
import script from "./ToolkitsForm.vue?vue&type=script&lang=js&"
export * from "./ToolkitsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports